import { frontendURL } from '../../../helper/URLHelper';
import VisitasIndex from '../visitas/pages/VisitasIndex.vue';

const agendaRoute = {
  path: frontendURL('accounts/:accountId/agenda'),
  component: VisitasIndex,
  meta: { referenceAuthenticated: true },
};

export default agendaRoute;
